import React from 'react'
import Project from './Project'
import Title from './Title'

const Projects = () => {

    //Make projects array with name projects and contains id as one of the field
    const projects = [
        {
            id:1,
            title:"Delicious Sweets",
            description:"Delicious Sweets is a responsive website to showcase and sell sweets. User can explore available sweets and can order them.",
            github:"https://github.com/shreyanksinghal/Delicious-sweets",
            stack: [
                {
                    id:1,
                    name:"html",
                },
                {
                    id:2,
                    name:"css",
                }
            ],
            url:"https://delicious-sweets.netlify.app/",
        },
        {
            id:2,
            title:"Delicious Edible",
            description:"Delicious Edible is a responsive website to showcase foods of this restaurant so that customers can explore available foods and can order them.",
            github:"https://github.com/shreyanksinghal/Delicious-Edible",
            stack: [
                {
                    id:1,
                    name:"html",
                },
                {
                    id:2,
                    name:"css",
                }
            ],
            url:"https://delicious-edible.netlify.app/",
        },
        {
            id:3,
            title:"Leaderboard",
            description:"Leaderboard is a simple responsive website where we can add/update player's score and also can manage players who are there in game.",
            github:"https://github.com/shreyanksinghal/Leaderboard",
            stack: [
                {
                    id:1,
                    name:"Angular",
                },
                {
                    id:2,
                    name:"Bootstrap",
                },
                {
                    id:3,
                    name:"html",
                },
                {
                    id:4,
                    name:"css",
                }
            ],
            url:"https://game-leaderboard.netlify.app/",
        },
        {
            id:4,
            title:"Cooking Recipe Management",
            description:"The website where we can buy all ingredients of a particular recipe and can buy them or make them custom.",
            github:"https://github.com/shreyanksinghal/Leaderboard",
            stack: [
                {
                    id:1,
                    name:"Angular",
                },
                {
                    id:2,
                    name:"Bootstrap",
                },
                {
                    id:3,
                    name:"html",
                },
                {
                    id:4,
                    name:"css",
                }
            ],
            url:"https://recipe-ingredients.netlify.app",
        },
        {
            id:5,
            title:"T-shirt store",
            description:"Store to buy customized t-shirts for customers. Admin can manage categories for T-shirts as well as can can manage T-shirts. ",
            github:"https://github.com/shreyanksinghal/T-shirt-store",
            stack: [
                {
                    id:1,
                    name:"MongoDb",
                },
                {
                    id:2,
                    name:"ExpressJs",
                },
                {
                    id:3,
                    name:"ReactJs",
                },
                {
                    id:4,
                    name:"NodeJs",
                }
            ],
            url:"https://shirt-store.netlify.app/",
        }
    ]

    return (
        <section className="projects" id="projects">
            <Title title="projects"/>
            <div className="section-center">
                {projects.map((project)=> {
return <Project key={project.id} {...project} />
                })}
            </div>
        </section>
    )
}

export default Projects
